import React from 'react';
import * as ReactDOM from 'react-dom/client';
import Modal from 'react-modal';
import { App } from './App';

const rootElmt = document.getElementById('root') as HTMLElement;

if (rootElmt && rootElmt.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElmt, <App />);
} else {
  const root = ReactDOM.createRoot(rootElmt);
  root.render(<App />);
}
if (rootElmt) {
  Modal.setAppElement(rootElmt);
}

if (process.env.NODE_ENV === 'development') {
  const head = document.getElementsByTagName('head');
  const links = document.getElementsByTagName('link');

  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    if (link.getAttribute('rel') === 'icon') {
      link.remove();
    }
  }

  const newLink = document.createElement('link');
  newLink.setAttribute('rel', 'icon');
  newLink.setAttribute('href', 'assets/favicon-dev.png');
  head[0].appendChild(newLink);
}
